import React, { useState } from "react";
import { COLORS } from "../../Constants/AppColors.js";
import { useTranslation } from "react-i18next";
import "../../Translation/i18n";
import i18n from "i18next";

function AboutUsPage() {
  const { t } = useTranslation();

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth);
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight);
  const [directionState, setDirectionState] = useState("ltr");

  React.useEffect(() => {
    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("ltr");
    }

    function handleResize() {
      console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
      setInnerWidthState(window.innerWidth);
      setInnerHeightState(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    console.log("i18n.locale: " + i18n.language);
  });

  return (
    <div
      dir={directionState}
      style={{
        // backgroundImage: `url(${require("../../assets/home_bg.png")})`,
        backgroundColor: "#F7F8F9",
        width: innerWidthState + "px",
        height: innerHeightState - 100 + "px",
        backgroundSize: "cover",
        // flex: 1,
        // flexDirection: "row",
        display: "flex",
        // alignItems: "center",
      }}
    >
      {/* <div
        style={{
          backgroundImage: `url(${require("../../assets/about_us_image.png")})`,
          height: innerHeightState + "px",
          width: innerWidthState / 2 + "px",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      ></div> */}
      <img
        src={require("../../assets/about_us_image.png")}
        // height={40}
        // width={100}
        alt="logo"
        style={{
          marginTop: 10,
          marginBottom: 10,
          marginLeft: -(innerWidthState / 10),
        }}
      />
      <div
        style={{
          // height: innerHeightState - 80 + "px",
          width: innerWidthState / 3 + "px",

          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          justifyContent: "center",
          marginLeft: i18n.language.includes("en") ? 30 : 0,
          marginRight: i18n.language.includes("ar") ? 30 : 0,
        }}
      >
        <label
          style={{
            color: COLORS.PageTitleFirstColor,
            fontSize: 35,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
          }}
        >
          {t("about_us_pt1")}{" "}
          <label
            style={{
              color: COLORS.PageTitleSecondColor,
              fontSize: 35,
              textAlign: i18n.language.includes("en") ? "left" : "right",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Title"
                : "CI-Font-Title-ar",
            }}
          >
            {t("about_us_pt2")}
          </label>
        </label>
        <label
          style={{
            color: COLORS.TextColor,
            marginTop: 15,
            fontSize: 14,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            wordWrap: "break-word",
            whiteSpace: "pre-wrap",
            width: innerWidthState / 3 + "px",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Body-Text"
              : "CI-Font-Body-Text-ar",
          }}
        >
          {t("about_us_text")}
        </label>
      </div>
    </div>
  );
}

export default AboutUsPage;
